//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { mapGetters } from 'vuex';

export default {
  name: 'artist-avatar',
  components: {
    LoaderSpin: () => import('@motionelements/core/src/components/ui/LoaderSpin.vue'),
  },
  props: {
    // artist: Object,
    member: Object,
    loading: {
      type: Boolean,
      default: false,
    },
    link: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    // ...mapGetters({
    //   avatarUrl: 'user/getAvatarUrl',
    // }),
    heroLevel() {
      return _.get(this.member, 'heroLevel', _.get(this.member, 'hero_level')) || null;
    },
    url() {
      const url = _.get(this.member, 'html.url');
      return (this.link && url) ? this.$link(url).url() : null;
    },
    avatarImageUrl() {
      return _.get(this.member, 'avatar.url') || null;
    },
    gravatarImageUrl() {
      return _.get(this.member, 'gravatar.url') || null;
    },
    backgroundImageUrls() {
      if (this.avatarImageUrl) {
        return `url('${this.avatarImageUrl}')`;
      }
      return `url('${this.gravatarImageUrl}')`;
    },
  },
  methods: {
    // getBgImgUrl(url) {
    //   if (!url) {
    //     return;
    //   }
    //   if (url.startsWith('http')) {
    //     return url;
    //   }
    //   // eslint-disable-next-line
    //   return require(`@/assets-mockup/img/${url}`);
    // },
    // getAvatarUrl(url) {
    //   if (!url) {
    //     return;
    //   }
    //   if (!url.startsWith('http')) {
    //     // return url;
    //     return this.$siteUrl(`/artists/${url}`).url();
    //   }
    //   return url;
    // },
    getHeroBadgeImageUrl(url) {
      return url ? `https://static.motionelements.com/img/artists/hero/badges/${url}` : '';
    },
    // setAvatarAsBg(url) {
    //   return `background: url('${this.getBgImgUrl(url)}');`;
    // },
  },
};
